import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminTopbar from "../../component/AdminTopbar";
import { Filter, Plus, Trash2 } from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AddNewStrategicInitiative from "./AdminCompo/AddNewStrategicInitiative";
import NavbarDashboard from "../../component/NavbarDashboard";
import AddAssignee from "../../component/AddAssignee";
import { baseurl } from "../../Baseurl";
import axios from "axios";
import EditStrategicInitiative from "./AdminCompo/EditStrategicInitiative";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AdminStratagicManagement() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [viewMode, setViewMode] = useState("card");
  const [filters, setFilters] = useState({
    title: "",
    category: "",
    priority: "",
    department: "",
    status: "",
  });
  const [allData, setAllData] = useState([]);

  const adminID = localStorage.getItem("adminID");
  const org_id = localStorage.getItem("org_id");

  const fetchInitiatives = () => {
    axios
      .get(`${baseurl}getStrategicInitiativesByOrgId/${org_id}`)
      .then((res) => {
        const data = res.data;
        if (Array.isArray(data)) {
          setAllData(data);
        } else if (Array.isArray(data?.data)) {
          setAllData(data.data);
        } else {
          console.warn("Unexpected response format:", data);
          setAllData([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching initiatives:", err);
        setAllData([]);
      });
  };

  useEffect(() => {
    fetchInitiatives();
  }, [org_id]);

  const handleFilterChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const filteredData = allData.filter((item) => {
    return (
      (!filters.title ||
        item.title?.toLowerCase().includes(filters.title.toLowerCase())) &&
      (!filters.category || item.category === filters.category) &&
      (!filters.priority || item.priority === filters.priority) &&
      (!filters.department || item.department === filters.department) &&
      (!filters.status || item.status === filters.status) &&
      (!startDate || new Date(item.start_date) >= new Date(startDate)) &&
      (!endDate || new Date(item.end_date) <= new Date(endDate))
    );
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this initiative?"))
      return;

    try {
      await axios.delete(`${baseurl}deleteStrategicInitiativeById/${id}`);
      toast.success("Strategic initiative deleted successfully");
      // Optionally reload or update UI here
      fetchInitiatives();
    } catch (error) {
      toast.error("Failed to delete initiative");
      console.error(error);
    }
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <div style={{ flexGrow: 1, padding: "0px" }}>
          <AdminTopbar />
          <NavbarDashboard />
          <div className="px-4">
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h2 className="chart-title text-start">
                    Strategic Initiative
                  </h2>
                  <div className="d-flex align-items-center  ">
                    <Filter className="me-3" />

                    <AddNewStrategicInitiative />
                    <AddAssignee />

                    <div className="btn-group ms-1" role="group">
                      <button
                        className={`btn btn-sm  oneline ${
                          viewMode === "table"
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => setViewMode("table")}
                      >
                        Table View
                      </button>
                      <button
                        className={`btn btn-sm oneline ${
                          viewMode === "card"
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => setViewMode("card")}
                      >
                        Card View
                      </button>
                    </div>
                  </div>
                </div>

                {/* Filters */}
                <div className="row g-1 mb-3">
                  <div className="col-md-3">
                    <input
                      name="title"
                      value={filters.title}
                      onChange={handleFilterChange}
                      className="form-control form-control-filter"
                      placeholder="Search Title"
                    />
                  </div>
                  <div className="col">
                    <select
                      name="category"
                      value={filters.category}
                      onChange={handleFilterChange}
                      className="form-control form-control-filter"
                    >
                      <option value="">Select Category</option>
                      <option value="Logistics">Logistics</option>
                      <option value="Operations">Operations</option>
                      <option value="Finance">Finance</option>
                    </select>
                  </div>
                  <div className="col">
                    <select
                      name="priority"
                      value={filters.priority}
                      onChange={handleFilterChange}
                      className="form-control form-control-filter"
                    >
                      <option value="">Priority</option>
                      <option value="High">High</option>
                      <option value="Medium">Medium</option>
                      <option value="Low">Low</option>
                    </select>
                  </div>
                  <div className="col">
                    <select
                      name="department"
                      value={filters.department}
                      onChange={handleFilterChange}
                      className="form-control form-control-filter"
                    >
                      <option value="">Department</option>
                      <option value="Logistics">Logistics</option>
                      <option value="HR">HR</option>
                      <option value="Admin">Admin</option>
                      <option value="Finance">Finance</option>
                    </select>
                  </div>
                  <div className="col">
                    <select
                      name="status"
                      value={filters.status}
                      onChange={handleFilterChange}
                      className="form-control form-control-filter"
                    >
                      <option value="">Status</option>
                      <option value="Ongoing">Ongoing</option>
                      <option value="Closed">Closed</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </div>
                  <div className="col">
                    <DatePicker
                      className="form-control form-control-filter"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="dd, MMM yyyy"
                      placeholderText="Start date"
                    />
                  </div>
                  <div className="col">
                    <DatePicker
                      className="form-control form-control-filter"
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="dd, MMM yyyy"
                      placeholderText="End date"
                    />
                  </div>
                </div>

                {/* Table */}
                {viewMode === "table" ? (
                  <div className="table-responsive mt-2">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Title</th>
                          <th>Category</th>
                          <th>Priority</th>
                          <th>Department</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.length > 0 ? (
                          filteredData.map((item) => (
                            <tr key={item.id}>
                              <td>{item.title}</td>
                              <td>{item.category}</td>
                              <td>{item.priority}</td>
                              <td>{item.department}</td>
                              <td>
                                {new Date(item.start_date).toLocaleDateString()}
                              </td>
                              <td>
                                {new Date(item.due_date).toLocaleDateString()}
                              </td>
                              <td>
                                <span
                                  className={`badge bg-${
                                    item.status.toLowerCase() === "closed"
                                      ? "secondary"
                                      : "success"
                                  }`}
                                >
                                  {item.status}
                                </span>
                              </td>
                              <td>
                                <div className="dropdown">
                                  <button
                                    className="btn btn-sm btn-outline-dark dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                  >
                                    Actions
                                  </button>
                                  <ul className="dropdown-menu">
                                    <li>
                                      <Link className="dropdown-item" to={`/`}>
                                        View
                                      </Link>
                                    </li>
                                    <li>
                                      <Link className="dropdown-item" to={`/`}>
                                        Edit
                                      </Link>
                                    </li>
                                    <li>
                                      <button className="dropdown-item text-danger">
                                        Delete
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No matching records
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="row g-3 text-start">
                    {filteredData.length > 0 ? (
                      filteredData.map((item) => (
                        <div className="col-md-3" key={item.id}>
                          <div className="card p-1  shadow-sm h-100">
                            <div className="card-body d-flex flex-column justify-content-between">
                              <div className="d-flex justify-content-between align-items-start mb-3">
                                <h5 className="card-title">{item.title}</h5>
                                {/* <div className="dropdown">
          <button className="btn btn-sm btn-outline-dark dropdown-toggle" data-bs-toggle="dropdown">
            Actions
          </button>
          <ul className="dropdown-menu">
            <li><Link className="dropdown-item" to={`/`}>View</Link></li>
            <li><Link className="dropdown-item" to={`/`}>Edit</Link></li>
            <li><button className="dropdown-item text-danger">Delete</button></li>
          </ul>
        </div> */}
                              </div>
                              <div className="mb-2">
                                <strong>Category:</strong> {item.category}
                              </div>
                              <div className="mb-2">
                                <strong>Priority:</strong>{" "}
                                <span
                                  className={`badge priority-${item.priority.toLowerCase()}`}
                                >
                                  {item.priority}
                                </span>
                              </div>
                              <div className="mb-2">
                                <strong>Department:</strong> {item.department}
                              </div>
                              <div className="mb-2">
                                <strong>Start:</strong>{" "}
                                {new Date(item.start_date).toLocaleDateString()}
                              </div>
                              <div className="mb-2">
                                <strong>End:</strong>{" "}
                                {new Date(item.due_date).toLocaleDateString()}
                              </div>
                              <div className="mb-3">
                                <strong>Status:</strong>{" "}
                                <span
                                  className={`badge status-${item.status
                                    .toLowerCase()
                                    .replace(" ", "-")}`}
                                >
                                  {item.status}
                                </span>
                              </div>
                              <div className="btn-group w-100">
                                {/* <button className="btn btn-sm btn-outline-primary">View</button> */}
                                <EditStrategicInitiative id={item.id} />
                                {/* <button className="btn btn-sm btn-outline-danger">Delete</button> */}
                                <button
                                  onClick={() => handleDelete(item.id)}
                                  className="btn btn-sm btn-outline-danger d-flex justify-content-center align-items-center"
                                >
                                  <Trash2 size={15} />
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center">No matching records</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={3000} // Toast disappears after 3 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default AdminStratagicManagement;
